import React from "react";
import { useDispatch, useStore } from "../../store";

import {
  Button,
  Card,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogTitleActions,
  DialogScroll,
  Type,
} from "discover.medical.react-component-library";

import { InputCheckbox, ColumnLayout } from "./_.styled";
import { fetchAlerts } from "../../store/actions/alerts";
import isEqual from "lodash/isEqual";

export const CategoryDialog = ({
  isOpen,
  setIsOpen,
  defaultSelected,
  setDefaultSelected,
}) => {
  const { categories, selectedCategoryIds } = useStore().categories || {};
  const dispatch = useDispatch();
  const [selected, setSelected] = React.useState(defaultSelected);
  // fires when apply button is clicked
  const applyFilters = (e) => {
    const categoryIds = [];
    selected.forEach((category) => {
      categoryIds.push(...category.ids);
    });
    if (isEqual(selectedCategoryIds, categoryIds)) {
      return;
    }
    setDefaultSelected(selected);
    fetchAlerts(dispatch, categoryIds);
    setIsOpen(false);
  };

  // fires when clear button is clicked
  const clearFilters = (e) => {
    setSelected([]);
  };

  // fires when a checkbox is selected or deselected
  const handleChange = (e, category) => {
    const { checked } = e.target;

    // The user checks the box
    if (checked) {
      setSelected([...selected, category]);
    }

    // The user unchecks the box
    else {
      setSelected(selected.filter((item) => item.title !== category.title));
    }
  };

  // fires when the dialog is closed
  const closeDialog = () => {
    setSelected(defaultSelected);
    setIsOpen(false);
  };

  return (
    <Dialog
      aria-labelledby="dialog-title"
      isOpen={isOpen}
      maxWidth="md"
      onRequestClose={closeDialog}
    >
      <DialogTitle
        borderBottomColor="gray300"
        borderBottomStyle="solid"
        borderBottomWidth="1px"
      >
        <Type id="dialog-title" element="h3">
          Filter by Topic Categories
        </Type>
        <DialogTitleActions onRequestClose={closeDialog} isFloating={true} />
      </DialogTitle>
      <DialogScroll style={{ maxHeight: "calc(100vh - 200px)" }}>
        <Card>
          <ColumnLayout>
            {categories &&
              categories.map((category) => (
                <InputCheckbox
                  key={category.title}
                  label={category.title}
                  name={category.title}
                  id={`uc_${category.title}`}
                  checked={selected.includes(category)}
                  value={category.title}
                  onChange={(e) => handleChange(e, category)}
                />
              ))}
          </ColumnLayout>
        </Card>
      </DialogScroll>
      <DialogActions
        borderTopColor="gray300"
        borderTopStyle="solid"
        borderTopWidth="1px"
        style={{ justifyContent: "space-between" }}
      >
        <Button kind="anchor" onClick={clearFilters}>
          Clear
        </Button>
        <Button onClick={applyFilters}>Apply</Button>
      </DialogActions>
    </Dialog>
  );
};

export default CategoryDialog;
